"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guessISOFormat = guessISOFormat;
var constants_1 = require("./constants");
var ISO_DATE_WITHOUT_MILLISECOND_REGEXP = /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d(Z|[+-]\d\d:\d\d)$/i;
/**
* Refer to the "Formats" section of "https://www.w3.org/TR/NOTE-datetime-970915"
* for the six valid levels of ISO 8601 standard.
*
* We only support the #6 and #5 levels(two most completed format).
* */
function guessISOFormat(date) {
    return date && ISO_DATE_WITHOUT_MILLISECOND_REGEXP.test(date)
        ? constants_1.ISO8601_DATE_WITHOUT_MILLISECOND_FORMAT
        : constants_1.ISO8601_DATE_FOMART;
}
